import { converterDataEua, converterDataHoraBr } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import { ILoteTerceiros } from "../interfaces/ILoteTerceiros";

export const COLUNAS_EXPORTACAO_LOTES_TERCEIROS = [
  "Lote",
  "Fornecedor",
  "E-mails",
  "Enviado em",
  "Usuário",
  "Placas",
];

export function linhasExportacaoLotesTerceiros(lotes: ILoteTerceiros[]) {
  return lotes.map((lote) => ({
    Lote: lote.id,
    Fornecedor: lote.fornecedor ?? "",
    "E-mails": lote.emails.join(", "),
    "Enviado em": converterDataHoraBr(lote.criadoEm) ?? "",
    Usuário: lote.usuario ?? "",
    Placas: lote.qtdPlacas,
  }));
}

export function exportarLotesTerceirosXlsx(
  lotes: ILoteTerceiros[],
  hoje: Date = new Date()
) {
  const planilha = utils.json_to_sheet(linhasExportacaoLotesTerceiros(lotes), {
    header: [...COLUNAS_EXPORTACAO_LOTES_TERCEIROS],
  });
  const arquivo = utils.book_new();

  utils.book_append_sheet(arquivo, planilha, "Lotes");
  writeFileXLSX(
    arquivo,
    `placas_terceiros_lotes_${converterDataEua(hoje)}.xlsx`
  );
}
